module.exports = __webpack_public_path__ + "img/player.68010c2d.png";